/**
 * SchedulingOAuthCallback — OAuth popup callback page
 *
 * Google redirects the OAuth popup to this frontend page.
 * It exchanges the authorization code with the API, then posts
 * the result to the opener window via postMessage (same-origin,
 * no cross-origin issue) and closes itself.
 *
 * @story SCRUM-1599 — OAuth callback redirect + calendar selection flow
 */

import { useEffect } from 'react';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3030';

export default function SchedulingOAuthCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    const error = params.get('error');

    if (error || !code || !state) {
      if (window.opener) {
        window.opener.postMessage({
          type: 'scheduling_oauth_complete',
          success: false,
          error: error || 'Missing OAuth parameters',
        }, window.location.origin);
      }
      window.close();
      return;
    }

    fetch(
      `${API_BASE_URL}/api/v1/admin/scheduling/callback?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`,
      { credentials: 'include' }
    )
      .then((res) => {
        if (!res.ok) {
          return res.json().then((body) => {
            throw new Error(body.error || `OAuth failed (${res.status})`);
          });
        }
        return res.json();
      })
      .then((data) => {
        if (window.opener) {
          window.opener.postMessage({
            type: 'scheduling_oauth_complete',
            success: true,
            credential_id: data.credential_id,
            scheduler_email: data.scheduler_email,
            calendars: data.calendars,
          }, window.location.origin);
        }
        window.close();
      })
      .catch((err) => {
        if (window.opener) {
          window.opener.postMessage({
            type: 'scheduling_oauth_complete',
            success: false,
            error: err.message,
          }, window.location.origin);
        }
        window.close();
      });
  }, []);

  return (
    <div style={{ padding: '2rem', fontFamily: 'sans-serif', textAlign: 'center' }}>
      <p>Connecting calendar… this window will close automatically.</p>
    </div>
  );
}
